import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EmailInBioChange } from '../models/emailInBioChange';

@Injectable({ providedIn: 'root' })
export class EmailInBioChangeService {

  constructor(private http: HttpClient) {}

  getEmailInBioChanges(date: string): Observable<EmailInBioChange[]> {
    const url = `${environment.apiUrl}emailinbiochanges?date=${date}`;
    return this.http.get<EmailInBioChange[]>(url);
  }
}
